// * This file may be splitted into multiple files in the future for better organization

// * Accounts
export const ACCOUNT_CMS_USERS_URL = '/accounts/cms/users/';
export const DEFERRED_USER_GROUPS_URL = '/accounts/deferred_user_groups/';
export const DEFERRED_USER_GROUPS_BY_ID_URL = (groupId: number) =>
  `/accounts/deferred_user_groups/${groupId}/` as const;
export const EMAIL_VALIDATION_URL = (token: string) =>
  `/accounts/email-validation/${token}/` as const;
export const EMAIL_VALIDATION_RESEND_URL = (email: string) =>
  `/accounts/email-validation/${email}/resend/` as const;
export const PASSWORD_RESET_URL = '/accounts/password_reset/';
export const PASSWORD_RESET_CONFIRM_URL = '/accounts/password_reset/confirm/';
export const PASSWORD_RESET_VALIDATE_TOKEN_URL = '/accounts/password_reset/validate_token/';
export const PROFILE_BY_USER_ID_URL = (userId: number) => `/accounts/profile/${userId}/` as const;
export const SPOT_USER_GROUPS_URL = '/accounts/spot_user_groups/';
export const SPOT_USER_GROUPS_BY_ID_URL = (groupId: number) =>
  `/accounts/spot_user_groups/${groupId}/` as const;
export const TIMEZONES_URL = '/accounts/timezones/';
export const TOKEN_PAIR_URL = '/accounts/token/pair/';
export const TOKEN_LOGOUT_URL = '/accounts/token/logout/';
export const TOKEN_MICROSOFT_PAIR_URL = '/accounts/token/ms_entra_pair/';
export const TOKEN_ME_URL = '/accounts/token/me/';
export const USER_URL = '/accounts/user/';
export const USER_BY_ID_URL = (userId: number) => `/accounts/user/${userId}/` as const;

// * Charge Points
export const CHARGEPOINT_GROUPS_URL = '/chargepoints/charge_point_groups/';
export const CHARGEPOINT_GROUP_BY_ID_URL = (groupId: number) =>
  `/chargepoints/charge_point_groups/${groupId}/` as const;
export const CHARGEPOINTS_URL = '/chargepoints/charge_points/';
export const CHARGEPOINTS_COMPOSITE_SCHEDULE_URL = (chargePointId: number) =>
  `/chargepoints/charge_points/${chargePointId}/composite_schedule/` as const;
export const CHARGEPOINTS_RESET_URL = (chargePointId: number) =>
  `/chargepoints/charge_points/${chargePointId}/reset/` as const;
export const CHARGEPOINTS_TRIGGER_MESSAGE_URL = (chargePointId: number) =>
  `/chargepoints/charge_points/${chargePointId}/trigger_message/` as const;
export const CHARGEPOINTS_UPTIME_DAY_URL = (chargePointId: number) =>
  `/chargepoints/charge_points/${chargePointId}/uptime_day/` as const;
export const CHARGEPOINTS_BY_ID_URL = (chargePointId: number) =>
  `/chargepoints/charge_points/${chargePointId}/` as const;
export const CHARGEPOINTS_BY_ASSET_ID_URL = (assetId: number) =>
  `/chargepoints/charge_points/by_asset/${assetId}/` as const;
export const CHARGEPOINTS_BY_GRID_CONNECTION_ID_URL = (gridConnectionId: number) =>
  `/chargepoints/charge_points/by_grid_connection/${gridConnectionId}/` as const;
export const CHARGING_PROFILES_URL = '/chargepoints/charging_profiles/';
export const CMS_CHARGEPOINTS_OCPP_URL = '/chargepoints/cms/chargepoints/';
export const CMS_CONNECTORS_URL = '/chargepoints/cms/connectors/';
export const CMS_SAMPLED_VALUES_URL = '/chargepoints/cms/sampled_values/';
export const CMS_TRANSACTION_REQUESTS_URL = '/chargepoints/cms/transaction_requests/';
export const CMS_TRANSACTIONS_URL = '/chargepoints/cms/transactions/';
export const CMS_TRANSACTIONS_REPORT_URL = '/chargepoints/cms/transactions/report/download/xlsx/';
export const COLLECTION_NOTES_URL = '/chargepoints/collection_notes/';
export const COLLECTION_NOTES_SUMMARY_URL = '/chargepoints/collection_notes/summary/';
export const CONNECTORS_URL = '/chargepoints/connectors/';
export const CONNECTORS_MANUAL_FIELDS_START_CHARGE_URL = (
  connectorId: number,
  vehicleNumberPlate: string,
  odometerValue: number | string
) =>
  `/chargepoints/connectors/${connectorId}/${vehicleNumberPlate}/${odometerValue}/manual_fields_start_charge/` as const;
export const CONNECTORS_UPTIME_BETWEEN_URL = (
  connectorId: number,
  startDate: string, // ? This should probably be validated with a zod schema
  endDate: string
) => `/chargepoints/connectors/${connectorId}/uptime/between/${startDate}/${endDate}/` as const;
export const CONNECTORS_BY_ID_URL = (connectorId: number) =>
  `/chargepoints/connectors/${connectorId}/` as const;
export const CONNECTORS_BY_ASSET_ID_URL = (assetId: number) =>
  `/chargepoints/connectors/by_asset/${assetId}/` as const;
export const CONNECTORS_ONLINE_BY_ASSET_ID_URL = (assetId: number) =>
  `/chargepoints/connectors/by_asset/${assetId}/online/` as const;
export const CONNECTORS_BY_GRID_CONNECTION_ID_URL = (gridConnectionId: number) =>
  `/chargepoints/connectors/by_grid_connection/${gridConnectionId}/` as const;
export const CONNECTORS_ONLINE_BY_GRID_CONNECTION_ID_URL = (gridConnectionId: number) =>
  `/chargepoints/connectors/by_grid_connection/${gridConnectionId}/online/` as const;
export const HEARTBEAT_BY_ID_URL = (heartBeatId: number) =>
  `/chargepoints/heartbeat/${heartBeatId}/` as const;
export const SAMPLED_VALUES_BY_ID_URL = (sampledValueId: number) =>
  `/chargepoints/sampled_values/${sampledValueId}/` as const;
export const SAMPLED_VALUES_BY_TRANSACTION_URL = (transactionId: number) =>
  `/chargepoints/sampled_values/by_transaction/${transactionId}/` as const;
export const STATUS_NOTIFICATIONS_BY_ASSET_ID_URL = (assetId: number) =>
  `/chargepoints/status_notifications/by_asset/${assetId}/` as const;
export const STATUS_NOTIFICATIONS_BY_ASSET_ID_BETWEEN_DATES_URL = (
  assetId: number,
  startDate: string, // ? This should probably be validated with a zod schema
  endDate: string
) =>
  `/chargepoints/status_notifications/by_asset/${assetId}/between/${startDate}/${endDate}/` as const;
export const STATUS_NOTIFICATION_BY_CHARGE_POINT_ID_URL = (chargePointId: number) =>
  `/chargepoints/status_notifications/by_charge_point/${chargePointId}/` as const;
export const STATUS_NOTIFICATION_BY_CHARGE_POINT_ID_BETWEEN_DATES_URL = (
  chargePointId: number,
  startDate: string, // ? This should probably be validated with a zod schema
  endDate: string
) =>
  `/chargepoints/status_notifications/by_charge_point/${chargePointId}/between/${startDate}/${endDate}/` as const;
export const SUMMARY_URL = '/chargepoints/summary/';
export const SUMMARY_XLSX_URL = '/chargepoints/summary/xlsx/';
export const TRANSACTIONS_URL = '/chargepoints/transactions/';
export const TRANSACTIONS_BY_ID_URL = (transactionId: number) =>
  `/chargepoints/transactions/${transactionId}/` as const;
export const TRANSACTIONS_BETWEEN_DATES_URL = (
  startDate: string, // ? This should probably be validated with a zod schema
  endDate: string
) => `/chargepoints/transactions/between/${startDate}/${endDate}/` as const;
export const TRANSACTIONS_BY_CHARGE_POINT_ID_URL = (chargePointId: number) =>
  `/chargepoints/transactions/by_charge_point/${chargePointId}/` as const;

// * CMS
export const CMS_CHARGEPOINTS_URL = '/cms/chargepoints/';
export const CMS_HISTORY_CHARGING_SESSIONS_URL = '/cms/history-charging-sessions/';
export const CMS_HISTORY_CHARGING_SESSIONS_SALES_DOWNLOAD_XLSX_URL =
  '/cms/history-charging-sessions/sales/download/xlsx/';
export const CMS_HISTORY_PAYMENTS_URL = '/cms/history-payments/';
export const CMS_HISTORY_PAYMENTS_SALES_DOWNLOAD_XLSX_URL =
  '/cms/history-payments/sales/download/xlsx/';
export const CMS_USER_GROUPS_URL = '/cms/user-groups/';
export const CMS_USERS_URL = '/cms/users/';

// * Company
export const ASSETS_URL = '/company/assets/';
export const ASSETS_BY_ID_URL = (assetId: number | string) =>
  `/company/assets/${assetId}/` as const;
export const CMS_ASSETS_URL = '/company/cms/assets/';
export const CMS_CONTRACTS_URL = '/company/cms/contracts/';
export const CMS_CONTRACT_SNAPSHOTS_URL = '/company/cms/contracts_snapshots/';
export const COMPANY_CMS_USER_GROUPS_URL = '/company/cms/user_groups/'; // ? revisar que tiene de distinto con la de CMS
export const CONTRACTS_URL = '/company/contracts/';
export const CONTRACTS_BY_ID_URL = (contractId: number) =>
  `/company/contracts/${contractId}/` as const;
export const FLEETS_URL = '/company/fleets/';
export const FLEETS_BY_ID_URL = (fleetId: number) => `/company/fleets/${fleetId}/` as const;
export const GRID_CONNECTIONS_URL = '/company/grid_connections/';
export const GRID_CONNECTIONS_BY_ID_URL = (gridConnectionId: number) =>
  `/company/grid_connections/${gridConnectionId}/` as const;
export const GRID_CONNECTIONS_BY_ID_COMPOSITE_SCHEDULE_URL = (gridConnectionId: number) =>
  `/company/grid_connections/${gridConnectionId}/composite_schedule/` as const;
export const GET_CHARGE_POINTS_POWER_BY_GRID_CONNECTION_ID_URL = (gridConnectionId: number) =>
  `/company/grid_connections/${gridConnectionId}/get_charge_points_power/` as const;
export const GET_ELECTRICITY_METERS_POWER_BY_GRID_CONNECTION_ID_URL = (gridConnectionId: number) =>
  `/company/grid_connections/${gridConnectionId}/get_electricity_meters_power/` as const;
export const GRID_CONNECTIONS_BY_ASSET_ID_URL = (assetId: number) =>
  `/company/grid_connections/by_asset/${assetId}/` as const;
export const POWER_CATEGORY_URL = '/company/power_category/';
export const USER_GROUPS_URL = '/company/user_groups/'; // ? revisar que tiene de distinto con la de CMS
export const USER_GROUPS_BY_ID_URL = (groupId: number) =>
  `/company/user_groups/${groupId}/` as const;
export const USER_GROUPS_PARSE_CSV_BY_ID_URL = (groupId: number) =>
  `/company/user_groups/${groupId}/parse_csv/` as const;
export const VEHICLE_STATION_URL = '/company/vehicle_station/';
export const WHITE_LABEL_VARIABLES_URL = '/company/whitelabel_variables/';

// * CS
export const CHARGING_AUTHORIZATIONS_URL = '/cs/charging_authorizations/';
export const CHARGING_AUTHORIZATIONS_BY_ID_URL = (authorizationId: number) =>
  `/cs/charging_authorizations/${authorizationId}/` as const;

// * Customization
export const THEME_URL = '/customization/theme/';

// * Kushki
export const KUSHKI_PAYMENTS_URL = '/kushki/payments/';
export const DOWNLOAD_KUSHKI_PAYMENTS_XLSX_URL = '/kushki/payments/download/xlsx/';

// * Metadata
export const TASK_STATUS_BY_ID_URL = (taskId: number | string) =>
  `/metadata/task_status/${taskId}/` as const;

// * Notifications
export const ACTIONS_URL = '/notifications/actions/';
export const IN_APP_URL = '/notifications/notifications/in_app/';
export const IN_APP_BY_ID_URL = (notificationId: number) =>
  `/notifications/notifications/in_app/${notificationId}/` as const;
export const EMAIL_SUBSCRIPTIONS_URL = '/notifications/subscriptions/email/';
export const IN_APP_SUBSCRIPTIONS_URL = '/notifications/subscriptions/in_app/';

// * Telemetry
export const TRACKER_LOG_BY_ID_URL = (trackerLogId: number) =>
  `/telemetry/tracker_log/${trackerLogId}/` as const;
export const TRACKER_LOG_BY_TRACKER_PATH_ID_URL = (trackerPathId: number) =>
  `/telemetry/tracker_log/by_tracker_path/${trackerPathId}/` as const;
export const TRACKER_LOG_BY_VEHICLE_ID_URL = (vehicleId: number | string) =>
  `/telemetry/tracker_log/by_vehicle/${vehicleId}/` as const;
export const TRACKER_LOG_BY_VEHICLE_ID_BETWEEN_DATES_URL = (
  vehicleId: number | string,
  startDate: string, // ? This should probably be validated with a zod schema
  endDate: string
) => `/telemetry/tracker_log/by_vehicle/${vehicleId}/between/${startDate}/${endDate}/` as const;
export const TRACKER_PATH_BY_FLEET_ID_URL = (fleetId: number) =>
  `/telemetry/tracker_path/by_fleet/${fleetId}/` as const;
export const TRACKER_PATH_BY_FLEET_ID_BETWEEN_DATES_URL = (
  fleetId: number,
  startDate: string, // ? This should probably be validated with a zod schema
  endDate: string
) => `/telemetry/tracker_path/by_fleet/${fleetId}/between/${startDate}/${endDate}/` as const;
export const TRACKER_PATH_BY_VEHICLE_ID_URL = (vehicleId: number | string) =>
  `/telemetry/tracker_path/by_vehicle/${vehicleId}/` as const;
export const TRACKER_PATH_BY_VEHICLE_ID_BETWEEN_DATES_URL = (
  vehicleId: number | string,
  startDate: string, // ? This should probably be validated with a zod schema
  endDate: string
) => `/telemetry/tracker_path/by_vehicle/${vehicleId}/between/${startDate}/${endDate}/` as const;
export const VEHICLE_URL = '/telemetry/vehicle/';
export const VEHICLE_BY_ID_URL = (vehicleId: number | string) =>
  `/telemetry/vehicle/${vehicleId}/` as const;
